//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0]],[[["numConnections"],"GetConnectionNames",{R_:{names:""}},0,0],[["names"],"SetConnectionNames",{},1,0],[["connectionName","remoteIP","remotePort","localIP","localPort","rcvBufSize","sendBufSize","updateTime","numSignals","signals"],"GetConnectionInformation",{},1,0],[["connectionName","remoteIP","remotePort","localIP","localPort","rcvBufSize","sendBufSize","updateTime","signals"],"SetConnectionInformation",{},9,0]],[]];
SPLM.Mechatronics.TCPSignalServerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.TCPSignalServerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.TCPSignalServerBuilder.Signal = class{
    constructor(signalTag,bChecked,offset){
        this.signalTag=signalTag;this.bChecked=bChecked;this.offset=offset;}
    get Signaltag(){return this.signalTag}
    set Signaltag(val){this.signalTag = val}
    get Bchecked(){return this.bChecked}
    set Bchecked(val){this.bChecked = val}
    get Offset(){return this.offset}
    set Offset(val){this.offset = val}
};

export default SPLM;